import React, { Component } from "react";
import { Modal, Input, Form, InputNumber, Button } from "antd";

class ModalRequest extends Component {
  state = {
    checkButtonSend: false,
    loadingButton: false,
    requestPrice: null,
    requestNotes: null,
  };

  // ************************* Function Change Data *************************//
  checkButtonSend() {
    const { requestPrice, requestNotes } = this.state;
    if (requestPrice && requestNotes) {
      this.setState({ checkButtonSend: true });
    } else {
      this.setState({ checkButtonSend: false });
    }
  }

  changeRequestPrice(price) {
    this.setState({ requestPrice: price }, () => this.checkButtonSend());
  }

  changeRequestNotes(e) {
    this.setState({ requestNotes: e.target.value }, () =>
      this.checkButtonSend()
    );
  }

  emptyState() {
    const { requestPrice, requestNotes } = this.state;
    this.setState({
      requestNotes: null,
      requestPrice: null,
      checkButtonSend: false,
    });
  }

  // ************************* Function Button Send *************************//
  async sendRequestButton() {
    const { requestPrice, requestNotes } = this.state;
    const data = {
      requestPrice,
      branchHeadNotes: requestNotes,
    };
    this.setState({ loadingButton: true });
    await this.props.sendButton(data, this.props.title);
    this.emptyState();
    this.setState({ loadingButton: false });
    this.props.visibleModal(this.props.title, false);
  }

  render() {
    return (
      <Modal
        footer={[null]}
        title={`Request ${this.props.title}`}
        visible={this.props.visible}
        onCancel={() => {
          this.props.visibleModal(this.props.title, false), this.emptyState();
        }}
      >
        {/* Form Masukkan Request */}
        <Form.Item label={`Masukkan ${this.props.title}`}>
          <InputNumber
            formatter={value =>
              `Rp. ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={value => value.replace(/Rp.\s?|(,*)/g, "")}
            style={{ width: "100%", marginBottom: 10 }}
            size="large"
            value={this.state.requestPrice}
            onChange={v => this.changeRequestPrice(v)}
          />
          <span style={{ opacity: "0.8" }}>*Request Pengajuan Discount</span>
        </Form.Item>
        {/* End Form Masukkan Request */}

        {/* Form Notes*/}
        <Form.Item label="Notes">
          <Input.TextArea
            value={this.state.requestNotes}
            rows={4}
            onChange={v => this.changeRequestNotes(v)}
          />
        </Form.Item>
        {/* End Form Notes*/}

        {/* Button Send Request*/}
        <Button
          disabled={this.state.checkButtonSend ? false : true}
          block
          loading={this.state.loadingButton}
          size="large"
          type="primary"
          onClick={() => this.sendRequestButton()}
        >
          SEND REQUEST
        </Button>
        {/* End Button Send Request*/}
      </Modal>
    );
  }
}

export default ModalRequest;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Modal/ModalRequest.js